import { render } from "./VUEAppHeader.vue?vue&type=template&id=b8688392"
import script from "./VUEAppHeader.vue?vue&type=script&lang=js"
export * from "./VUEAppHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__